'use client';
import Typography from '@/components/shared/typography/typography.component';
import React, { FC } from 'react';
import { useTranslation } from '@/hook';

const AvailableChip: FC<{ available: boolean }> = ({ available }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '2px 8px 2px 6px',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: available ? '#E6FBF2' : '#FEF3F2',

        borderRadius: '16px',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      <div
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: available ? '#00CE7C' : '#F04438',
        }}
      />
      <Typography
        variant="captionMedium"
        color={available ? '#00673E' : '#B42318'}
        style={{ whiteSpace: 'nowrap' }}
      >
        {available ? t('available_m') : t('Not Available')}
      </Typography>
    </div>
  );
};

export default AvailableChip;
